/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetSafetyConsultantDefectRecordResponse } from '../models/get-safety-consultant-defect-record-response';
import { CreateSafetyConsultantDefectRecordRequest } from '../models/create-safety-consultant-defect-record-request';
import { UpdateSafetyConsultantDefectRecordRequest } from '../models/update-safety-consultant-defect-record-request';
@Injectable({
  providedIn: 'root',
})
class SafetyConsultantDefectRecordService extends __BaseService {
  static readonly SafetyConsultantDefectRecordGetAllPath = '/SafetyConsultantDefectRecord/GetAll';
  static readonly SafetyConsultantDefectRecordGetByIdPath = '/SafetyConsultantDefectRecord/GetById';
  static readonly SafetyConsultantDefectRecordCreatePath = '/SafetyConsultantDefectRecord/Create';
  static readonly SafetyConsultantDefectRecordCreateRangePath = '/SafetyConsultantDefectRecord/CreateRange';
  static readonly SafetyConsultantDefectRecordUpdatePath = '/SafetyConsultantDefectRecord/Update';
  static readonly SafetyConsultantDefectRecordUploadFilePath = '/SafetyConsultantDefectRecord/UploadFile';
  static readonly SafetyConsultantDefectRecordDeletePath = '/SafetyConsultantDefectRecord/Delete';
  static readonly SafetyConsultantDefectRecordDeleteRangePath = '/SafetyConsultantDefectRecord/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  SafetyConsultantDefectRecordGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetSafetyConsultantDefectRecordResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/SafetyConsultantDefectRecord/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetSafetyConsultantDefectRecordResponse>>;
      })
    );
  }  SafetyConsultantDefectRecordGetAll(): __Observable<Array<GetSafetyConsultantDefectRecordResponse>> {
    return this.SafetyConsultantDefectRecordGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetSafetyConsultantDefectRecordResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  SafetyConsultantDefectRecordGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetSafetyConsultantDefectRecordResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefectRecord/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetSafetyConsultantDefectRecordResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  SafetyConsultantDefectRecordGetById(Id?: string): __Observable<GetSafetyConsultantDefectRecordResponse> {
    return this.SafetyConsultantDefectRecordGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetSafetyConsultantDefectRecordResponse)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordCreateResponse(request: CreateSafetyConsultantDefectRecordRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefectRecord/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordCreate(request: CreateSafetyConsultantDefectRecordRequest): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordCreateRangeResponse(request: Array<CreateSafetyConsultantDefectRecordRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefectRecord/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordCreateRange(request: Array<CreateSafetyConsultantDefectRecordRequest>): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordUpdateResponse(request: UpdateSafetyConsultantDefectRecordRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/SafetyConsultantDefectRecord/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  SafetyConsultantDefectRecordUpdate(request: UpdateSafetyConsultantDefectRecordRequest): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SafetyConsultantDefectRecordService.SafetyConsultantDefectRecordUploadFileParams` containing the following parameters:
   *
   * - `SafetyConsultantPeriodicReportId`:
   *
   * - `RecordId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   *
   * - `DefectId`:
   */
  SafetyConsultantDefectRecordUploadFileResponse(params: SafetyConsultantDefectRecordService.SafetyConsultantDefectRecordUploadFileParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.SafetyConsultantPeriodicReportId != null) { __formData.append('SafetyConsultantPeriodicReportId', params.SafetyConsultantPeriodicReportId as string | Blob);}
    if (params.RecordId != null) { __formData.append('RecordId', params.RecordId as string | Blob);}
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    if (params.DefectId != null) { __formData.append('DefectId', params.DefectId as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/SafetyConsultantDefectRecord/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `SafetyConsultantDefectRecordService.SafetyConsultantDefectRecordUploadFileParams` containing the following parameters:
   *
   * - `SafetyConsultantPeriodicReportId`:
   *
   * - `RecordId`:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   *
   * - `DefectId`:
   */
  SafetyConsultantDefectRecordUploadFile(params: SafetyConsultantDefectRecordService.SafetyConsultantDefectRecordUploadFileParams): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordUploadFileResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  SafetyConsultantDefectRecordDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantDefectRecord/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  SafetyConsultantDefectRecordDelete(id?: string): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  SafetyConsultantDefectRecordDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/SafetyConsultantDefectRecord/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  SafetyConsultantDefectRecordDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.SafetyConsultantDefectRecordDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module SafetyConsultantDefectRecordService {

  /**
   * Parameters for SafetyConsultantDefectRecordUploadFile
   */
  export interface SafetyConsultantDefectRecordUploadFileParams {
    SafetyConsultantPeriodicReportId?: string;
    RecordId?: null | string;
    File?: null | Blob;
    DirectoryPath?: null | string;
    DefectId?: string;
  }
}

export { SafetyConsultantDefectRecordService }
